import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4002Model } from './kymw4002.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW4002PromotionModel } from './vo/kymw4002-promotion.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { DeletePromotionListService } from './api-services/delete-promotion-list.service';
import { RegistPromotionListService } from './api-services/regist-promotion-list.service';
import { UpdatetPromotionListService } from './api-services/update-promotion-list.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';

/**
 * プロモーションマスタメンテナンス画面を管理するクラス
 *
 * @export KYMW4002Component
 * @class KYMW4002Component
 */
@Component({
  selector: 'app-kymw4002',
  templateUrl: 'kymw4002.component.html',
  styleUrls: ['kymw4002.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW4002Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw4002Model: KYMW4002Model = new KYMW4002Model();

  @ViewChild('btn_Delete', { static: true }) btn_Delete: ElementRef;

  /**
   * Creates an instance of KYMW4002Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {DeletePromotionListService} deletePromotionListService
   * @param {RegistPromotionListService} registPromotionListService
   * @param {UpdatetPromotionListService} updatetPromotionListService
   * @memberof KYMW4002Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private deletePromotionListService: DeletePromotionListService,
    private registPromotionListService: RegistPromotionListService,
    private updatetPromotionListService: UpdatetPromotionListService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW4002Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4002';
    setTimeout(() => {
      this.plessEnabledSetting();
    });
  }

  // 活性・非活性制御処理
  plessEnabledSetting() {
    // ボタン制御
    // 起動モード(0：登録、1：更新)で削除ボタンを活性/非活性
    if (this.kymw4002Model.mode === 0) {
      this.plessEnabled(this.btn_Delete, false);
    } else {
      this.plessEnabled(this.btn_Delete, true);
    }
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW4002Component
   */
  public setInterfaceParam(param: any): void {
    this.kymw4002Model.mode = param.mode;
    this.kymw4002Model.promotionNo = param.promotionNo;
    this.kymw4002Model.promotionInfo = param.promotionInfo;
    this.kymw4002Model.markCode1 = param.markCode1 === '' ?
    '' : PlessViewUtilsSub.padding(param.markCode1, 3, '0', 1);
    this.kymw4002Model.markCode2 = param.markCode2 === '' ?
    '' : PlessViewUtilsSub.padding(param.markCode2, 3, '0', 1);
    this.kymw4002Model.markCode3 = param.markCode3 === '' ?
    '' : PlessViewUtilsSub.padding(param.markCode3, 3, '0', 1);
    this.kymw4002Model.markCode4 = param.markCode4 === '' ?
    '' : PlessViewUtilsSub.padding(param.markCode4, 3, '0', 1);
    this.kymw4002Model.markCode5 = param.markCode5 === '' ?
    '' : PlessViewUtilsSub.padding(param.markCode5, 3, '0', 1);
    this.kymw4002Model.multiPublishFlag = param.multiPublishFlag;
  }

  /**
   * 更新ボタンを押下した時に呼び出される
   *
   * @memberof KYMW4002Component
   */
  public eventUpdateButton_CLICKHandler(): void {
    const kymw4002PromotionVO: KYMW4002PromotionModel = new KYMW4002PromotionModel();
    kymw4002PromotionVO.promotionNo = this.kymw4002Model.promotionNo;
    kymw4002PromotionVO.promotionInfo = this.kymw4002Model.promotionInfo;
    kymw4002PromotionVO.markCode1 = this.kymw4002Model.markCode1;
    kymw4002PromotionVO.markCode2 = this.kymw4002Model.markCode2;
    kymw4002PromotionVO.markCode3 = this.kymw4002Model.markCode3;
    kymw4002PromotionVO.markCode4 = this.kymw4002Model.markCode4;
    kymw4002PromotionVO.markCode5 = this.kymw4002Model.markCode5;
    kymw4002PromotionVO.multiPublishFlag = PlessViewUtilsSub.booleanTOString(this.kymw4002Model.multiPublishFlag);

    // 起動モードのチェック
    if (this.kymw4002Model.mode === 1) {                                        // 「1：更新」の場合
      // 02. プロモーションマスタ情報更新API呼び出し
      this.updatetPromotionListService.execute(this.kymw4002Model, kymw4002PromotionVO,
        (data: any) => super.onClickWindowClose());
    } else {                                                                    // 上記以外の場合
      // 01. プロモーションマスタ情報登録API呼び出し
      this.registPromotionListService.execute(this.kymw4002Model, kymw4002PromotionVO,
        (data: any) => super.onClickWindowClose());
    }
  }

  /**
   * 削除ボタンを押下した時に呼び出される
   */
  public eventDeleteButton_CLICKHandler(): void {
    // 確認メッセージ表示
    this.dialogService.openAlertGetMessage('Q0106', ['プロモーションマスタ'],
      (detail: number) => this.eventDeleteButton_OKHandler(detail));

  }

  /**
   * 確認ダイアログを閉じたときに呼び出される
   *
   * @param {number} detail 押下ボタン番号
   * @memberof KYMW4002Component
   */
  public eventDeleteButton_OKHandler(detail: number): void {
    if (detail === PlessAlert.Yes) {
      const kymw4002PromotionVO: KYMW4002PromotionModel = new KYMW4002PromotionModel();
      kymw4002PromotionVO.promotionNo = this.kymw4002Model.promotionNo;

      // 03. プロモーションマスタ情報削除API呼び出し
      this.deletePromotionListService.execute(this.kymw4002Model, kymw4002PromotionVO,
        (data: any) => super.onClickWindowClose());
    }
  }

}
